// extracted by mini-css-extract-plugin
module.exports = {"boxTools":"nzsQOTMb608Y4ybzVb1Gp","btnTool":"_15LQhswAFontSfyO2RcWCk","active":"_3fVnSKXOZoGk0SS4qd0rZ3"};